import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO from "@/components/SEO";
import LanguageToggle from "@/components/LanguageToggle";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { useI18n } from "@/i18n";

const Privacy = () => {
  const { t } = useI18n();

  return (
    <>
      <SEO
        title={`${t("privacy.seo.title")} | ${t("brand.name")}`}
        description={t("privacy.seo.description")}
        canonical="https://trimr.cc/confidentialite"
        keywords={t("privacy.seo.keywords")}
      />
      <main className="min-h-screen bg-gradient-to-b from-background to-secondary/20 py-12 px-4">
        <div className="max-w-4xl mx-auto space-y-8">
          <div className="flex items-center justify-between gap-3">
            <Link to="/">
              <Button variant="ghost" className="gap-2">
                <ArrowLeft className="w-4 h-4" />
                {t("nav.backHome")}
              </Button>
            </Link>
            <LanguageToggle />
          </div>

          <Breadcrumbs items={[{ label: t("privacy.title") }]} />

          <div className="text-center space-y-4 mb-8">
            <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-primary via-primary/80 to-primary bg-clip-text text-transparent">
              {t("privacy.title")}
            </h1>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              {t("privacy.subtitle")}
            </p>
          </div>

          <Card className="border-0 shadow-xl">
            <CardHeader>
              <CardTitle className="text-2xl">{t("privacy.s1.title")}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4 text-muted-foreground leading-relaxed">
              <p>
                <strong className="text-foreground">{t("privacy.s1.account.label")}</strong>{" "}
                {t("privacy.s1.account.text")}
              </p>
              <p>
                <strong className="text-foreground">{t("privacy.s1.links.label")}</strong>{" "}
                {t("privacy.s1.links.text")}
              </p>
              <p>
                <strong className="text-foreground">{t("privacy.s1.clicks.label")}</strong>{" "}
                {t("privacy.s1.clicks.text")}
              </p>
              <p>
                <strong className="text-foreground">{t("privacy.s1.security.label")}</strong>{" "}
                {t("privacy.s1.security.text")}
              </p>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-xl">
            <CardHeader>
              <CardTitle className="text-2xl">{t("privacy.s2.title")}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4 text-muted-foreground leading-relaxed">
              <ul className="list-disc pl-6 space-y-2">
                <li>{t("privacy.s2.i1")}</li>
                <li>{t("privacy.s2.i2")}</li>
                <li>{t("privacy.s2.i3")}</li>
              </ul>
              <p>{t("privacy.s2.note")}</p>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-xl">
            <CardHeader>
              <CardTitle className="text-2xl">{t("privacy.s3.title")}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4 text-muted-foreground leading-relaxed">
              <ul className="list-disc pl-6 space-y-2">
                <li>{t("privacy.s3.i1")}</li>
                <li>{t("privacy.s3.i2")}</li>
                <li>{t("privacy.s3.i3")}</li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-xl">
            <CardHeader>
              <CardTitle className="text-2xl">{t("privacy.s4.title")}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4 text-muted-foreground leading-relaxed">
              <p>{t("privacy.s4.text")}</p>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-xl">
            <CardHeader>
              <CardTitle className="text-2xl">{t("privacy.s5.title")}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4 text-muted-foreground leading-relaxed">
              <p>{t("privacy.s5.p1")}</p>
              <p>
                {t("privacy.s5.p2.before")}{" "}
                <Link to="/contact" className="text-primary underline underline-offset-4">
                  {t("privacy.s5.p2.link")}
                </Link>
                {t("privacy.s5.p2.after")}
              </p>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-xl">
            <CardHeader>
              <CardTitle className="text-2xl">{t("privacy.s6.title")}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4 text-muted-foreground leading-relaxed">
              <p>{t("privacy.s6.text")}</p>
            </CardContent>
          </Card>
        </div>
      </main>
    </>
  );
};

export default Privacy;
